import { createFileRoute, redirect } from "@tanstack/react-router";
import { isLocalMode } from "../../../lib/appMode";
import { localServerId } from "../../../lib/localSession";

export const Route = createFileRoute("/_authed/settings/")({
  beforeLoad: () => {
    if (isLocalMode) {
      // The server-hosted app has no account pages: land on this server.
      const serverId = localServerId();
      if (serverId) {
        throw redirect({ to: "/settings/server/$serverId/general", params: { serverId } });
      }
      throw redirect({ to: "/settings/quality" });
    }
    throw redirect({ to: "/settings/account" });
  },
});
